module.exports = `
<p><strong><span style="font-size:21px;line-height:107%;">INTER AMERICAN DEVELOPMENT BANK&rsquo;S PRIVACY POLICY&nbsp;</span></strong></p>
<i>To be defined...</i>
`;
